// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kdWE","left":"styles_left__E-pua","desktopActions":"styles_desktopActions__VhY4f","title":"styles_title__3T1XN"};